var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    style: {
      color: "#36abff"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.965 10.725a.196.196 0 0 1 .005-.005l5.25-5.25 2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-.53.22H4.5a.75.75 0 0 1-.75-.75v-2.266a.747.747 0 0 1 .215-.51Zm2.785 1.714 4.19-4.189-1.19-1.19-4.19 4.19 1.19 1.19ZM10.81 6 12 7.19 13.19 6 12 4.81 10.81 6Z",
    clipRule: "evenodd"
  })));
};
export default SvgEdit;